import React, {useEffect, useRef, useState} from 'react';
import Breadcrumb from '../../../components/BreadCrumb/breadCrumb';
import Strings from '../../../constants/stringConstant';
import Path from '../../../constants/path';
import sharedStyles from '../Masters.module.css';
import {Box, Grid, IconButton} from '@mui/material';
import SearchBox from '../../../components/SearchBox/searchBox';
import ButtonComp from '../../../components/Button/buttonComp';
import {ReactComponent as UploadIcon} from '../../../assets/images/upload_icon.svg';
import {ReactComponent as AddIcon} from '../../../assets/images/addIconWhite.svg';
import PaginationComp from '../../../components/Pagination/paginationComp';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import AddEditConsumerDurable from './AddEditConsumerDurable';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import makeApiCall from '../../../api/makeApiCall';
import {
  updateConsumerMaster,
  bulkDownloadMaster,
  bulkUploadMaster,
  fetchCdMaster,
} from '../../../api/request/masterFetchApi/masterFetchApi';
import SuccessModal from '../../../components/Modal/successModal';
import PartialUploadModal from '../StateMasters/partialUploadModal';
import {ReactComponent as EditSharpIcon} from '../../../assets/images/editIcon.svg';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import {useSelector} from 'react-redux';
import {ReactComponent as DownloadIcon} from '../../../assets/images/downloadOrange.svg';

function ConsumerDurableMaster() {
  const {t: translator} = useTranslation();
  const paths = [
    {
      name: Strings.masters.masters,
      link: Path.masters_consumer_master,
    },
    {name: Strings.masters.consumer_durable_master, link: ''},
  ];
  const fileInputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [addEditStateModal, setAddEditStateModal] = useState(false);
  const [type, setType] = useState('add');
  const [selectedRowObject, setSelectedRowObject] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [uploadSuccessModal, setUploadSuccessModal] = useState(false);
  const [uploadFailedModal, setUploadFailedModal] = useState(false);
  const [failedRecords, setFailedRecords] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState('');
  const [partialUpload, setPartialUpload] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const {roleBased} = useSelector(state => state.rbacValue);
  const isEditState = roleBased?.masters?.sections?.state_master !== 'edit';
  const rowPerTable = 10;

  function toggleAddEditStateModal() {
    setAddEditStateModal(!addEditStateModal);
  }

  useEffect(() => {
    fetchCdMasterApi();
  }, [searchQuery, currentPage]);

  useEffect(() => {
    if (successModal) {
      setTimeout(() => {
        handleSuccessModal();
      }, 2000);
    }
  }, [successModal]);

  useEffect(() => {
    if (failedModal) {
      setTimeout(() => {
        handleFailedModal();
      }, 2000);
    }
  }, [failedModal]);

  useEffect(() => {
    if (uploadSuccessModal) {
      setTimeout(() => {
        setUploadSuccessModal(false);
      }, 2000);
    }
  }, [uploadSuccessModal]);
  useEffect(() => {
    if (uploadFailedModal) {
      setTimeout(() => {
        setUploadFailedModal(false);
      }, 2000);
    }
  }, [uploadFailedModal]);

  const handleApiError = response => {
    let errorCode = response?.data?.error?.errorCode;
    let errorMessage = translator(`ErrorMessages.${errorCode}`);
    if (errorCode === 'SAMASTA013') {
      setNoRecordsFound(true);

      return;
    }
    if (errorCode === 'SAMASTA088' || errorCode === 'SAMASTA166') {
      toast.error(response?.data?.error?.errorMessage, {position: 'top-right'});

      return;
    }
    if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
      errorCode = 'SAMASTA001';
      errorMessage = translator('ErrorMessages.SAMASTA001');
    }

    if (errorCode !== 'SAMASTA015') {
      toast.error(errorMessage, {position: 'top-right'});
    }
  };

  const fetchCdMasterApi = async (
    pageNumber = currentPage,
    searchVal = searchQuery,
  ) => {
    setLoading(true);
    try {
      const requestPayload = {
        pageNumber: pageNumber - 1,
        pageSize: rowPerTable,
        searchTerm: searchVal,
      };
      const response = await makeApiCall(fetchCdMaster(requestPayload));
      if (response?.data?.status === Strings?.success) {
        const data = response?.data?.data?.content ?? [];
        setRows(data);
        setTotalPages(
          Math.ceil(response?.data?.data?.totalElements / rowPerTable),
        );
        if (data?.length === 0) {
          setNoRecordsFound(true);
        } else {
          setNoRecordsFound(false);
        }
      } else {
        handleApiError(response);
      }
    } catch (error) {
      toast.error(Strings.apiError, {position: 'top-right'});
    } finally {
      setLoading(false);
    }
  };

  const updateConsumerMasterApi = async formData => {
    setLoading(true);
    try {
      const requestPayload = {
        id: formData?.id || null,
        cdCode: formData?.cdCode || '',
        cdType: formData?.cdType || '',
        brand: formData?.brand || '',
        productColor: formData?.productColor || '',
        modelNumber: formData?.modelNumber || '',
        vendor: formData?.vendor || '',
        customerSellingPrice: formData?.customerSellingPrice || '',
        status: formData?.status,
      };
      const response = await makeApiCall(updateConsumerMaster(requestPayload));
      console.log(response, 'asdasdasd');
      if (response?.data?.status === Strings?.success) {
        setSuccessModal(true);
        fetchCdMasterApi(currentPage, searchQuery);
      } else {
        handleApiError(response);
        setFailedModal(true);
        setSuccessModal(false);
      }
    } catch (error) {
      toast.error(Strings.apiError, {position: 'top-right'});
    } finally {
      setLoading(false);
    }
  };

  const loanColumns = [
    {label: 'CD code', field: 'cdCode'},
    {label: 'CD type', field: 'cdType'},
    {label: 'Brand', field: 'brand'},
    {label: 'Product colour', field: 'productColor'},
    {label: 'Model number', field: 'modelNumber'},
    {label: 'Vendor', field: 'vendor'},
    {label: 'Customer selling price (₹)', field: 'customerSellingPrice'},
  ];
  const handleSearch = query => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleSuccessModal = () => {
    setSuccessModal(false);
  };
  const handleFailedModal = () => {
    setFailedModal(false);
  };
  const bulkUploadDocumentData = async file => {
    try {
      const formData = new FormData();
      formData.append('excelFile', file);
      formData.append('masterType', 'CONSUMER_DURABLE');
      const response = await makeApiCall(bulkUploadMaster(formData));
      if (response?.data?.status === Strings.success) {
        const message = response?.data?.successMessage;
        const totalRecordCounts = response?.data?.data?.totalRecordCount || 0;
        setTotalRecordCount(totalRecordCounts);
        if (message === 'Partial Upload Done') {
          setFailedRecords(response?.data?.data?.failedRows || []);
          setPartialUpload(true);
        } else {
          setUploadSuccessModal(true);
        }
        fetchCdMasterApi(currentPage, searchQuery);
      } else {
        setUploadFailedModal(true);
        // handleApiError(response);
      }
    } catch (error) {
      setUploadFailedModal(true);
      toast.error(Strings.apiError, {
        position: 'top-right',
      });
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (
      file.type !==
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      toast.error('Only Xlsx files are allowed.');
      fileInputRef.current.value = '';

      return;
    }
    bulkUploadDocumentData(file);
  };

  const handleDocumentUpload = () => {
    fileInputRef.current.click();
  };
  const handleDownload = async () => {
    try {
      const payload = {
        templateName: 'CONSUMER_DURABLE',
      };
      const response = await makeApiCall(bulkDownloadMaster(payload));
      if (response?.data?.status === Strings.success) {
        toast.success('File downloaded successfully.');
        const responseValue = response?.data?.data;
        window.open(responseValue.signedUrl, '_blank', 'noopener,noreferrer');
        fetchCdMasterApi(currentPage, searchQuery);
      } else if (
        response?.data?.error?.errorCode === translator('ErrorCodes.SAMASTA015')
      ) {
        toast.warning('No document found');
      } else {
        toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
          position: 'top-right',
        });
      }
    } catch (error) {
      console.log(
        'An error occurred at Download Document Execution-component',
        error,
      );
      toast.error(translator('ErrorMessages.' + 'SAMASTA001'), {
        position: 'top-right',
      });
    }
  };
  const handleStatusChange = selectedRow => {
    setSelectedRowObject(selectedRow);
    setModalVisible(true);
  };
  const handleStatusCancel = () => {
    setModalVisible(false);
    setSelectedRowObject({});
  };
  const handleConfirm = async () => {
    setLoading(true);
    try {
      const updatedStatus = !selectedRowObject.status;
      const requestPayload = {
        ...selectedRowObject,
        status: updatedStatus,
      };
      const response = await makeApiCall(updateConsumerMaster(requestPayload));
      if (response?.data?.status === Strings.success) {
        fetchCdMasterApi(currentPage, searchQuery);
        setModalVisible(false);
        setSelectedRowObject({});
      } else {
        handleApiError(response);
      }
    } catch (error) {
      console.error('API Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={sharedStyles.main_container}>
      <Breadcrumb paths={paths} />
      <Box className={sharedStyles.secondary_container}>
        {/* search and other buttons container */}
        <Grid
          container
          sx={{
            gap: '12px',
            justifyContent: 'space-between',
          }}>
          <Grid item>
            <SearchBox searchQuery={searchQuery} onSearch={handleSearch} />
          </Grid>
          <Grid item>
            {' '}
            <Grid
              container
              sx={{
                gap: '12px',
              }}>
              <ButtonComp
                variant="outlined"
                className="text-bold-16px"
                endIcon={<UploadIcon />}
                value={Strings.masters.bulk_upload}
                height="40px"
                padding="12px 16px"
                textcolor="#F37021"
                border="1px solid #F37021"
                borderRadius="8px"
                onClick={handleDocumentUpload}
                disabled={isEditState}
              />
              {
                <input
                  type="file"
                  accept=".xlsx"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  style={{display: 'none'}}
                />
              }
              <ButtonComp
                variant="outlined"
                className="text-bold-16px"
                endIcon={<DownloadIcon />}
                value={Strings.masters.download}
                height="40px"
                padding="12px 16px"
                textcolor="#F37021"
                border="1px solid #F37021"
                borderRadius="8px"
                onClick={handleDownload}
                disabled={isEditState}
              />
              <ButtonComp
                type="submit"
                className="text-bold-16px"
                endIcon={<AddIcon />}
                value={Strings.masters.add_new}
                // disabled={!formik.dirty || !formik.isValid}
                gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                height="40px"
                padding="14px 24px"
                textcolor="#fff"
                borderRadius="8px"
                onClick={() => {
                  setType('add');
                  toggleAddEditStateModal();
                }}
                disabled={isEditState}
              />
            </Grid>
          </Grid>
        </Grid>
        <TableComp
          loader={loading}
          columns={loanColumns}
          rows={rows}
          editDisabled={isEditState}
          handleActionClick={row => {
            setType('edit');
            toggleAddEditStateModal();
            setSelectedRowObject(row);
            fetchCdMasterApi();
          }}
          showTotal={false}
          firstColumnBgColor={'white'}
          statusColumn={true}
          statusChange={handleStatusChange}
          noRecordsFound={noRecordsFound}
          actionIcon={
            <IconButton aria-label="close" disabled={isEditState}>
              <EditSharpIcon />
            </IconButton>
          }
        />
        {totalPages > 0 && !noRecordsFound && (
          <PaginationComp
            totalPages={totalPages}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        )}
      </Box>
      {addEditStateModal && (
        <ModalwithButton
          open={addEditStateModal}
          message={
            type === 'add'
              ? 'Add Consumer Durable details'
              : 'Edit Consumer Durable details'
          }
          subMessage={
            type === 'add' ?
              'Fill in the below details to add them to the master table' :
            'Edit the below details to update them to master table'
          }
          leftRenderWithoutPadding
          bolderHeadings
          subMessageColor={'#475467'}
          onClose={toggleAddEditStateModal}
          minWidth={'50%'}>
          <AddEditConsumerDurable
            closeModal={toggleAddEditStateModal}
            selectedRowObject={selectedRowObject}
            type={type}
            updateConsumerMaster={updateConsumerMasterApi}
          />
        </ModalwithButton>
      )}
      <SuccessModal
        open={successModal}
        onClose={handleSuccessModal}
        message={
          type === 'add'
            ? Strings.masters.added_record
            : Strings.masters.updated_record
        }
        subMessage={
          type === 'add'
            ? Strings.masters.added_record_des
            : Strings.masters.updated_record_des
        }
      />
      <SuccessModal
        open={failedModal}
        onClose={handleFailedModal}
        message={
          type === 'add'
            ? Strings.masters.failed_added_record
            : Strings.masters.failed_updated_record
        }
        subMessage={
          type === 'add'
            ? Strings.masters.failed_added_record_des
            : Strings.masters.failed_updated_record_des
        }
        reject
      />
      <SuccessModal
        open={uploadSuccessModal}
        onClose={() => setUploadSuccessModal(false)}
        message={Strings.masters.bulk_upload_success}
        subMessage={`All ${totalRecordCount} records have been successfully uploaded.`}
      />
      <SuccessModal
        open={uploadFailedModal}
        onClose={() => setUploadFailedModal(false)}
        message={Strings.masters.bulk_upload_failed}
        subMessage={Strings.masters.bulk_upload_failed_des}
        reject
      />
      {partialUpload && (
        <PartialUploadModal
          isOpen={partialUpload}
          onClose={() => setPartialUpload(false)}
          failedRecords={failedRecords}
          totalRecordCount={totalRecordCount}
        />
      )}
      <ModalwithButton
        open={isModalVisible}
        message={Strings.masters.status_change}
        subMessage={Strings.masters.status_change_msg}
        value={'Yes'}
        onClickButton={handleConfirm}
        onClose={handleStatusCancel}
        cancelBtn
      />
    </Box>
  );
}

export default ConsumerDurableMaster;
